import React, { useEffect, useState } from "react";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { getAllItemsData } from "../../Utility/Api";
import { endPoints, Image_Url } from "../../Constant/Environment";
import { getFullUrl } from "../../Constant/makeApiCall";
import MetaTags from '../MetaTags'; 
 
import { InfinitySpin } from 'react-loader-spinner'

function About() {
 
  const [isLoading, setIsLoading] = useState(false);
  const [aboutPageData, setAboutPageData] = useState({});

  const getAboutPageData = () => {
    let url = `${endPoints.api.ABOUT_PAGE_DATA}`;
    setIsLoading(true);

    getAllItemsData(url)
      .then((response) => {
        const { status, data } = response;
        if (status === 200) {
          setAboutPageData(data);
          setIsLoading(false);
           
        } else {
          // Handle error or show a message
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    
    getAboutPageData();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      {isLoading ? (
  
        <div className="page_loader"><InfinitySpin
          visible={true}
          width="200"
          color="#4fa94d"
          ariaLabel="infinity-spin-loading"
        /></div>
      ) : (
        <>
          <MetaTags
            title={aboutPageData && aboutPageData.meta_title}
            description={aboutPageData && aboutPageData.meta_descriptions}
            image={Image_Url + aboutPageData.banner}
            canonicalUrl={getFullUrl()}
          />

          <div className="banner-inner">
            {aboutPageData && aboutPageData.banner ? (
              <img
                src={Image_Url + aboutPageData.banner}
                alt="logo1"
                loading="lazy"
              />
            ) : null}
            <div className="banner-text">
              <h3 className="c-heading">
                {aboutPageData && aboutPageData.banner_title}
              </h3>
              <p>{aboutPageData && aboutPageData.banner_descriptions}</p>
            </div>
          </div>

          <main className="middle contact-page">
            <section className="pt-3">
              <div className="container">
                <Breadcrumb>
                  <Breadcrumb.Item>Welcome</Breadcrumb.Item>
                  <Breadcrumb.Item active>About Us</Breadcrumb.Item>
                </Breadcrumb>
                <div className="row g-0 sec-padd-t align-items-center">
                  <div className="col-md-6">
                    {aboutPageData && aboutPageData.left_banner ? (
                      <img
                        src={Image_Url + aboutPageData.left_banner}
                        alt="logo1"
                        loading="lazy" // Uncomment if you want to enable lazy loading
                      />
                    ) : null}
                  </div>
                  <div className="col-md-6 about-banner">
                    {aboutPageData && aboutPageData.right_banner ? (
                      <img
                        src={Image_Url + aboutPageData.right_banner}
                        alt="logo1"
                        loading="lazy" // Uncomment if you want to enable lazy loading
                      />
                    ) : null}
                    {/* <img
                      src={Image_Url + aboutPageData.right_banner}
                      alt="logo2"
                    /> */}
                  </div>
                </div>
              </div>
            </section>

            <section className="sec-padd pb-0">
              <Container>
                <Row className="justify-content-center">
                  <Col md={10}>
                    <h3 className="c-heading text-center">
                      {aboutPageData && aboutPageData.title}
                    </h3>
                    <p className="text-center mb-5 gray-color mt-4">
                      {aboutPageData && aboutPageData.descriptions}
                    </p>
                  </Col>
                </Row>
                <Row className="align-items-center justify-content-center">
                  <Col md={9} lg={8}>
                    <Row className="mt-5 mb-5 g-5">
                      <Col md={4}>
                        <div className="d-flex align-items-center">
                          <div className="about-img">
                            <img
                              src={require("../../Assets/Images/about-icon.webp")}
                              alt="logo1"
                            />
                          </div>
                          <div className="about-text">
                            <h4>{aboutPageData && aboutPageData.registered_users}</h4>
                            <p className="m-0">Registered Users</p>
                          </div>
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="d-flex align-items-center">
                          <div className="about-img">
                            <img
                              src={require("../../Assets/Images/about-icon01.webp")}
                              alt="logo1"
                            />
                          </div>
                          <div className="about-text">
                            <h4>{aboutPageData && aboutPageData.shipments_posted}</h4>
                            <p className="m-0">Shipments Posted</p>
                          </div>
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="d-flex align-items-center">
                          <div className="about-img">
                            <img
                              src={require("../../Assets/Images/about-icon02.webp")}
                              alt="logo1"
                            />
                          </div>
                          <div className="about-text">
                            <h4>{aboutPageData && aboutPageData.trips_posted}</h4>
                            <p className="m-0">Trips Posted</p>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row className="align-items-center justify-content-center mt-5">
                  <Col md={10}>
                    <img
                      src={require("../../Assets/Images/about-banner01.webp")}
                      alt="logo1"
                    />
                  </Col>
                </Row>
              </Container>
            </section>
          </main>
        </>)}
    </>
  );
}

export default About;
